// Bloco de cashback acima do CONFIRMAR PEDIDO (totem/balcão):
//   sem cliente → botão "Ganhe R$ X de cashback informando seu CPF" (vai pra identificação e volta);
//   com cliente → quanto vai ganhar neste pedido e, se tem saldo, o switch "Usar R$ Y da carteira".
// Pedido do dono (09/09/2026).
import { Coins, UserRound, Wallet } from "lucide-react";

import { Switch } from "../../components/ui/switch";
import { fmtBRL } from "./cashback";

export default function CashbackPagamento({ ativo, cliente, saldo, disponivel, aplicado, ganho, onAlternarUso, onIdentificar }) {
  if (!ativo) return null;

  if (!cliente) {
    return (
      <button
        type="button"
        onClick={onIdentificar}
        data-e2e="cashback-identificar"
        className="w-full mb-3 h-14 rounded-xl border-2 border-emerald-500/50 bg-emerald-500/10 text-emerald-300 font-bold text-base flex items-center justify-center gap-2 active:scale-95 transition-transform"
      >
        <Coins className="w-5 h-5" />
        Ganhe {fmtBRL(ganho)} de cashback informando seu CPF
        <UserRound className="w-5 h-5 opacity-70" />
      </button>
    );
  }

  return (
    <div className="mb-3 space-y-2" data-e2e="cashback-bloco">
      {ganho > 0 && (
        <p className="flex items-center justify-center gap-2 text-sm font-semibold text-emerald-300" data-e2e="cashback-ganho">
          <Coins className="w-4 h-4" /> Você ganha {fmtBRL(ganho)} de cashback neste pedido
        </p>
      )}
      {saldo > 0 && (
        <div className={`rounded-xl border-2 px-4 py-3 flex items-center gap-3 ${aplicado > 0 ? "border-emerald-500 bg-emerald-500/10" : "border-zinc-700 bg-zinc-900"}`}>
          <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center shrink-0"><Wallet className="w-5 h-5 text-emerald-400" /></div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-zinc-100">Usar {fmtBRL(disponivel)} da sua carteira</p>
            <p className="text-xs text-zinc-400">
              {aplicado > 0 ? `${fmtBRL(aplicado)} aplicado neste pedido.` : `Saldo: ${fmtBRL(saldo)}${disponivel < saldo ? " · vale só pra itens sem promoção" : ""}`}
            </p>
          </div>
          <Switch checked={aplicado > 0} onCheckedChange={onAlternarUso} disabled={disponivel <= 0} data-e2e="cashback-usar" className="data-[state=checked]:bg-emerald-500" />
        </div>
      )}
    </div>
  );
}
